import { ProductApiGridFieldFilter } from "./product-api-grid-field-filter.model";

export class ProductApiGridFilter {
  productApiId: number;
  disciplineName: string;
  deviceTypeId: number;
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  filterValues: ProductApiGridFieldFilter[];
}
